import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { CAUserDto } from 'src/core/models/administration/user/CAUser.dto';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserCacheService {
  simpleUserCache: CAUserDto[] = [];

  constructor(private http: HttpClient) {}

  getAndCacheUsers(userIds: string[]): Observable<CAUserDto[]> {
    let params = new HttpParams();
    var req = new Observable<CAUserDto[]>();

    var requestUserIds = userIds.filter(id => !this.simpleUserCache.map(u => u.id).includes(id));

    if (requestUserIds.length > 0) {
      params = new HttpParams();
      params = params.append('userIds', JSON.stringify(requestUserIds));
      const url = this.getApiUrl(CAUserDto) + '/bulk-simple-list';
      req = this.http.get<CAUserDto[]>(url, {
        params,
      }) as Observable<CAUserDto[]>;
    } else {
      req = of([...this.simpleUserCache.filter(u => userIds.includes(u.id))]);
    }

    req = req.pipe(
      tap(result => {
        let newUsers = result.filter(u => !this.simpleUserCache.map(x => x.id).includes(u.id));
        this.simpleUserCache = this.simpleUserCache.concat(...newUsers);
      })
    );

    return req;
  }

  protected getApiUrl(type = DtoHasApi): string {
    const apiBase = environment.apis.default.url;

    return apiBase.length > 0 ? apiBase + '/' + type.apiUrl : type.apiUrl;
  }
}
